import { t } from "i18next";
import { useNavigate } from "react-router-dom"
import { loginUser } from "../../../Helper/Context/action";
import { useState } from "react";
import { useAuthDispatch, useAuthState } from "../../../Helper/Context/context";
import '../../../theme/amchi-theme.css'

export default function SignUpPopup(props) {
    const { setSignUpShowPopup, CitizenField } = props

    const dispatch = useAuthDispatch()
    const userDetails = useAuthState();
    const { UserID, token } = userDetails

    const [userName, setuserName] = useState(CitizenField.UserName)
    const [password, setpassword] = useState(CitizenField.Password)
    const [loading, setloading] = useState(false)
    const [Validationerror, setValidationerror] = useState(false)
    const [Loginmessage, setLoginmessage] = useState('')

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        setLoginmessage('')
        e.preventDefault()
        // if (userName !== '' && password !== '') {
            try {
                let response = await loginUser(dispatch, { userName, password, setloading, handleRollIdWiseDashboard, handleErrorIdWiseDashboard, setLoginmessage });
                if (!response) return;
                // navigate('/dashboard');

            } catch (error) {
                console.log(error);
            }
            setValidationerror(false)
        // } else {
        //     setValidationerror(true)
            // if (userName == '') {
            //     document.getElementById('Username').classList.add('validation-error')
            // } else {
            //     document.getElementById('Username').classList.remove('validation-error')
            // }

            // if (password == '') {
            //     document.getElementById('Password').classList.add('validation-error')
            // } else {
            //     document.getElementById('Password').classList.remove('validation-error')
            // }
        // }

    }
    const handleRollIdWiseDashboard = (data) => {
        // console.log(data.m_RoleID)
        if (data.m_RoleID == 2 || data.m_RoleID == 3 || data.m_RoleID == 4) {
            navigate(`/DirectorDashboard`)
        } else if (data.m_RoleID == 5 || data.m_RoleID == 6) {
            navigate(`/MainDashboard`)
        }
        else if (data.m_RoleID == 7) {
            navigate(`/RegistrationDashboard?UserName=NewUser`)
            // navigate(`/DirectorDashboard`)
        } else if (data.m_RoleID == 1) {
            navigate(`/DesignationMaster`)
        }
    }
    const handleErrorIdWiseDashboard = (data) => {
        setLoginmessage(data)
    }
    return (
        <div className="am-page am-modal-backdrop" role="dialog" aria-modal="true">
            <div className="am-modal">
                <div className="am-modal-head">
                    <span className="am-login-avatar"><i className="fa-solid fa-circle-check"></i></span>
                    <h2>नोंदणी यशस्वी</h2>
                    <p>तुमचे लॉगिन तपशील खाली दिले आहेत</p>

                    <button
                        type="button"
                        className="am-modal-close"
                        aria-label="Close"
                        onClick={() => setSignUpShowPopup(false)}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>

                <div className="am-modal-body">
                    <label className="am-label">{t('CitizenRegistration.UserName')}</label>
                    <div className="am-field">
                        <i className="fa-solid fa-user"></i>
                        <input
                            type="text"
                            readOnly
                            placeholder={t('CitizenRegistration.UserName')}
                            name='UserName'
                            value={userName}
                        />
                    </div>

                    <label className="am-label">{t('CitizenRegistration.Password')}</label>
                    <div className="am-field">
                        <i className="fa-solid fa-lock"></i>
                        <input
                            type="text"
                            readOnly
                            placeholder={t('CitizenRegistration.Password')}
                            name='Password'
                            value={password}
                        />
                    </div>

                    <div className="am-form-msg">
                        <i className="fa-solid fa-circle-exclamation"></i>
                        <span>कृपया वापरकर्ता नाव व पासवर्ड पुढील वापरासाठी जतन करून ठेवा.</span>
                    </div>

                    <button
                        type="button"
                        className="am-submit"
                        disabled={loading}
                        onClick={handleSubmit}
                    >
                        {loading
                            ? <><i className="fa-solid fa-circle-notch fa-spin"></i> कृपया थांबा...</>
                            : <><i className="fa-solid fa-right-to-bracket"></i> Copy &amp; Login</>}
                    </button>

                    {Loginmessage &&
                        <div className="am-form-msg">
                            <i className="fa-solid fa-circle-exclamation"></i>
                            <span>{Loginmessage}</span>
                        </div>
                    }

                    <div className="am-form-actions" style={{ margin: '18px 0 0' }}>
                        <button
                            type="button"
                            className="am-btn am-btn--ghost"
                            onClick={() => setSignUpShowPopup(false)}
                        >
                            <i className="fa-solid fa-xmark"></i> Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}